import React from 'react'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const Index = ({List, search, onSearch}) => {
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input
          value={search || ''}
          onChange={(e)=>onSearch(e.target.value)}
          placeholder='Search invoice, doctor, status, department...'
        />
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              <div className='_th' style={{width:"10%"}}>Invoice</div>
              <div className='_th' style={{width:"30%"}}>Client</div>
              <div className='_th' style={{width:"15%"}}>Status</div>
              <div className='_th' style={{width:"15%"}}>Department</div>
              <div className='_th' style={{width:"15%"}}>Date</div>
              <div className='_th' style={{width:"15%",textAlign:"end"}}>Net Total</div>
            </div>
          </div>
          <div className='_tbody'>
            {List.length > 0 &&
              List.map((item,index)=>{
                return(
                  <div className='_tr' style={{padding:"5px 0px"}} key={index}>
                    <div className='_td' style={{width:"10%"}}>OR{item.id}</div>
                    <div className='_td' style={{width:"30%"}}>{item.doctorname}</div>
                    <div className='_td' style={{width:"15%"}}>{item.statusname}</div>
                    <div className='_td' style={{width:"15%"}}>{item.departmentname}</div>
                    <div className='_td' style={{width:"15%", backgroundColor:item.ordercolor}}>
                      {item.duedate.split('',10)}
                    </div>
                    <div className='_td' style={{width:"15%",textAlign:"end"}}>{item.nettotal}</div>
                  </div>
                )
              })
            }
            {List.length <= 0 &&
              <div className='table_nodata'>
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index
